<template>
  <div class="flex flex_gap_10">
    <v-popover
      class="d-inline"
      placement="bottom"
      :auto-hide="true"
    >
      <i class="icon-fa icon-fa-photo pointer" @click="uploadImage"></i>
      <template slot="popover">
        <template v-if="!drugsImage">
          Loading...
        </template>
        <template v-else>
          <img :src="drugsImage" alt="">
        </template>
      </template>
    </v-popover>
    <div>
      <p>{{ drug.title }}</p>
      <p>{{ drug.en_title }}</p>
<!--      <p class="text-muted" v-if="drug.pack_comment">{{ drug.pack_comment }}</p>-->
      <p class="text-muted" v-if="drug.pack_box_comment">{{ drug.pack_box_comment }}</p>
      <p v-if="drug.cool"><i class="icon icon-snowflake pull-left mr-2"/> Требуется хладоген</p>
      <p v-if="drug.pack_set != 1"><span class="badge badge-info">1 комплект ({{
          +drug.pack_set
        }} зав.уп.)</span></p>
    </div>
  </div>
</template>

<script>

import api from "@/api";

export default {
  props: ['drug'],
  data() {
    return {
      drugsImage: null
    }
  },
  methods: {
    async uploadImage() {
      if (this.drugsImage) return;
      const {data} = await api.post('/new/drugs/infoType', {
        types: ['projectInfo'],
        drug_id: this.drug.id,
        project_id: 1
      });
      if (data.success) {
        this.drugsImage = data.image_full;
      } else {
        toastr['warning'](data.message || 'Ошибка загрузки');
      }
    }
  }
}

</script>
